import { IsiSubMenuManager, IsiSubMainMenuManager } from "./Isilog/Menu/IsiSubMenuManager";
import { IsiMainMenuManager } from "./Isilog/Menu/IsiMainMenuManager";
import { getScreenInstance } from "./Isilog/Core/IsiIwsUICore";
import { appendSessionId, modifWaitStatus, appendDiagSessionId } from "./IsiPage.ts";
import { IsiShortcut } from "./Isilog.enums";
import { IsiRedirectJs, submitFormulaire } from "./basic";
import { IsiDtoGLOBXXXOpenArgs } from "./Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPopins";
import { getConfigurationFastMail } from "./Isilog.popins";
import { IsiActionContext } from "./Isilog/Core/IsiActionContext";
import { IsiPlDesign } from "./Isilog/PresentationLogic/IsiPlDesign";

/**
 * Traitement après validation d'un validator.
 * @param validator
 * @param submit
 */
function AfterValidatorValidation(validator, submit) {
    let submition = submit;
    if (!validator.isvalid) {
        submition = false;
        const ctrlID = validator.id.substring(validator.id.length - MASK_EDIT_VALIDATOR.length - 1, 0);
        const ctrl = document.getElementById(ctrlID + '_' + TEXTBOX);
        if (ctrl) {

            // On vide la variable stockant l'action en cours. Sinon, lorsque l'on change de langue,
            // on reposte la page et donc on lance l'action valider alors que tous les champs 
            // obligatoires n'etaient pas remplit.
            var ihdItemClick = <HTMLInputElement>document.getElementById("ihdItemClick");
            if (ihdItemClick) {
                ihdItemClick.value = "";
            }
            // On positionne le focus sur le premier element.
            iws_SetFocus(ctrlID + '_' + TEXTBOX);
        }
    }
    return submition;
}


/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : TGUE
'- Date        : 18/02/2010
'- Description : [DEV31267] - On va checker les validator
'-----------------------------------------------------------------------------------------*/
export function iws_checkValidators() {
    let submit = true;
    if (typeof (Page_Validators) !== "undefined") {
        // Si on a des validators
        if (Page_Validators) {
            // Si 1 des validator est faut, on arrete le traitement
            for (var i = 0; i < Page_Validators.length; i++) {
                ValidatorValidate(Page_Validators[i]);
                submit = AfterValidatorValidation(Page_Validators[i], submit)
            }
        }
    }
    return submit;
}
window.iws_checkValidators = iws_checkValidators;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : VLEB
'- Date        : 07/03/2006
'- Description : Permet de savoir si l'ecran en cours est un ecran avec une grille.
'-----------------------------------------------------------------------------------------*/
export function isScreenWithGrid() {
    return (isiApp.screen.name == "LIST003" || isiApp.screen.name == "GLOB005");
}
window.isScreenWithGrid = isScreenWithGrid;


/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : JBES
'- Date        : 15/11/2004
'- Description : Permet d'effectuer une validation sur la grille
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : JBES
'- Date        : 15/11/2004
'- Description : 
'-- PARAMETRES ---------------------------------------------------------------------------
' ENTREE
'-   -> sCtrlName : Nom du champ invisible utilise pour indiquer une validation sur la grille
'-   -> sAction  : Action effectuee sur la grille
'-----------------------------------------------------------------------------------------*/
export function actionOnGrid(sCtrlName, sAction) {
    if (document.getElementById(sCtrlName)) {
        (<HTMLInputElement>document.getElementById(sCtrlName)).value = sAction;
    }
}
window.actionOnGrid = actionOnGrid;

export function Menu_BeforeItemSelectedMenuNavig(sender, args) {
    Menu_BeforeItemSelected(null, args.value, null);
}
window.Menu_BeforeItemSelectedMenuNavig = Menu_BeforeItemSelectedMenuNavig;

// <summary>
//    indique, dans le controle ihdItemClick, quel est le menu selectionne.
//    Et mets a jour les infos concernant la position des details
// </summary>
// <param name="oItem">item selectionne dans le menu de gauche</param>
// <param name="sItemID">ID de l'item selectionne dans le menu de gauche</param>
// <param name="oEvent"></param>
// <remarks>
// </remarks>
// <history>
// 	[JBES]	31/08/2004	Created
// 	[GELA]	21/07/2009	Modified - Suppression du controle infragitics UltraWebListBar
//  [LLGU]	28/06/2012	Modified - Suppression du case list002 au niveau des traitements specifiques par ecrans ou Generique
//  [LLGU]  02/03/2016 Modified - POPIN
// </history>
export function Menu_BeforeItemSelected(oItem, sItemID, oEvent) {
    //console.profile("TimeBeforeShowConfirm");
    if (getScreenInstance()) {
        return screenCore.onClick(oItem, sItemID, oEvent);
    }
}
window.Menu_BeforeItemSelected = Menu_BeforeItemSelected;

/**
 *  Action lors du clique sur le panier marchand et retourne si l'action a ete traitee
 * @param action
 */
export function isiActMnuIcone(action: string) {
    //Dysf74182 - CLEM - Menu Home et deconnexion ne fonctionne plus apres une erreur 
    uiCore.clearTreatments();
    uiCore.setSubmit(provocateOnChange());

    var bTraite;
    // YLAR TOP de la maison du bandeau
    isiApp.startBench("Page");

    if (action === HOMEICONE) {
        const actionContext = uiCore.createActionContext();
        actionContext.uiAction = {
            menuBarId: MNU_ICONE_CLICK_GR,
            menuItemId: action,
            codeItemList: null,
            addDetailOnForm: false,
            data: undefined,
            detailName: undefined,
            group: undefined,
            id: MNU_ICONE_CLICK_GR + MNU_SEP + action,
            instanceName: undefined,
            isActionForm: false,
            key: undefined,
            menuGroupId: undefined,
            option: undefined
        }
        //118654 - Modification suite popin sur IwsConfirmLostModif
        screenCore.confirmLostModif(actionContext, null, null, {
            func: function () {
                return function (result) {
                    if (result === "PostWithoutSave") {
                        modifWaitStatus(true, true, LOADING);
                        const cp = uiCore.getElasticComponent();
                        if (cp && cp.state) {
                            cp.state.setRestoreState(false);
                            uiCore.saveState();
                        }
                        _registerClickInfo(IHD_ICONE_CLICK_ITEM_ID, action);
                        submitFormulaire();
                    }
                }
            }()
        });
        bTraite = true;
    }
    return bTraite;
}
window.isiActMnuIcone = isiActMnuIcone;

/**
 * Fonction permettant d'inscrire l'action dans le controle cache correspondant
 * @param controlID
 * @param action
 */
function _registerClickInfo(controlID, action) {
    (document.getElementById(controlID) as HTMLInputElement).value = action;
}

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : ABON
'- Date        : 23/03/2011
'- Description : [DEV41553] - Modification de l'image de fond du bouton IWS sur un hover
'- Rermarque   :              on ne peut pas utiliser la CSS pour ca car on est en mode Quirks (a desinguer des que possible si on passe en xhtml)
'-----------------------------------------------------------------------------------------*/
export function iws_SwapClass(id: string, className: string) {
    document.getElementById(id).className = className;
}
window.iws_SwapClass = iws_SwapClass;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : ABON
'- Date        : 12/04/2011
'- Description : [DEV41555] - Gestion des touches d'accessibilite du menu principal (reprise du code normea)
'-----------------------------------------------------------------------------------------*/
export function iws_MPAccKPress(evt) {
    if (window.tak["rootAccKey"] != undefined) {
        // keyCode contient le code clavier de la touche
        var keyCode = evt.keyCode;
        var idElement = window.tak["rootAccKey"][keyCode];

        // si nous ne sommes pas sur un ctrl alt ni un alt shift et qu'il existe une touche d'accessibilite

        if (evt.altKey && !evt.ctrlKey && !evt.shiftKey && idElement != undefined) {
            // et que l'on a pas deux touches d'accessibilitees ou plus cas des controles (on fait dans un if a part pour les perfs car si pas d'accessKey correspondant pour le menu
            // alors on ne cherche pas dans le dom)
            var key;
            key = String.fromCharCode(evt.keyCode);
            if (jQuery("[accesskey=" + key.toUpperCase() + "],[accesskey=" + key.toLowerCase() + "]", document).length == 1) {
                var pSubMenuMngr = window.mnuMngrPrinc.managers[idElement];
                try {
                    // si on a un menu courant et qu'il est affiche alors on ne fait que l'equivalent d'un mouseover
                    if (screenCore.menuManager.subMenuManagers[pSubMenuMngr.msMenuGroup] && screenCore.menuManager.subMenuManagers[pSubMenuMngr.msMenuGroup].mbMenuDisplay == true && screenCore.menuManager.subMenuManagers[pSubMenuMngr.msMenuGroup].msMenuGroup == pSubMenuMngr.msMenuGroup) {
                        pSubMenuMngr.OnMouseOver(evt);
                    } else {

                        //sinon on mouse over et on simule le clique
                        pSubMenuMngr.OnMouseOver(evt);
                        pSubMenuMngr.OnClick();
                    }
                    screenCore.menuManager.registerOpenedMenu(pSubMenuMngr.msMenuId);
                }
                // si probleme y a pas probleme ^^
                catch (e) {
                }
                return false;
            }
            // si on a appuyer sur une touche autre que alt ou que l'on a appuyer sur alt en dehors de ctrl alt et que l'on
        } else if ((evt.altLeft === false) || (evt.altLeft && evt.ctrlKey === false && typeof idElement === 'undefined')) {
            // on avait un menu d'affiche alors on le ferme
            if (screenCore.menuManager.subMenuManagers[pSubMenuMngr.msMenuGroup]) {
                screenCore.menuManager.subMenuManagers[pSubMenuMngr.msMenuGroup].ClosingRequest();
                screenCore.menuManager.removeOpenedMenu(pSubMenuMngr.msMenuId);
            }
        }
    }
    return true;
}
window.iws_MPAccKPress = iws_MPAccKPress;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : ABON
'- Date        : 23/03/2011
'- Description : [DEV41553] - Gestion du menu Bouton IWS
'-----------------------------------------------------------------------------------------*/
//var mnuMngrBtn;

export function initBtnMngr() {

    window.mnuMngrBtn = new IsiSubMenuManager('DivMenuBigbtn', null, 'iCbMenuLangue', 'mnuIws', null);

    //le placement a gauche de ce  menu est dynamique on le precise donc
    window.mnuMngrBtn.getLeftPos = function () {
        return document.getElementById('DivBanIco').offsetWidth - window.mnuMngrBtn.miWidth - 9; //-9 decalage a droite
    };

    // appele apres la traitement de fermeture du manager
    window.mnuMngrBtn.OnClose = function () {
        window.mnuMngrBtn.CloseSubMenu();
    };

    afterInitBtnMngr();
}
window.initBtnMngr = initBtnMngr;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : GBAU
'- Date        : 09/02/2012
'- Description : [DEV48201] - Portail Async
'-----------------------------------------------------------------------------------------*/
export function afterInitBtnMngr() {
    afterInitBtnMngrOverridable();
}
window.afterInitBtnMngr = afterInitBtnMngr;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : GBAU
'- Date        : 09/02/2012
'- Description : [DEV48201] - Portail Async
'-----------------------------------------------------------------------------------------*/
export function afterInitBtnMngrOverridable() {
    //Virtuel
}
window.afterInitBtnMngrOverridable = afterInitBtnMngrOverridable;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : ABON
'- Date        : 30/06/2011
'- Description : [] - Gestion du menu multi profil
'-----------------------------------------------------------------------------------------*/
//var mnuMngrProf;

export function initMMProf(menuID) {
    window.mnuMngrProf = new IsiSubMenuManager(menuID, null, null, "mnuProf", null);

    //le placement a gauche de ce  menu est dynamique on le precise donc
    window.mnuMngrProf.getLeftPos = function () {
        return -5;
    };
    // appele apres la traitement OnMouseOver du manager
    window.mnuMngrProf.OnMouseOverCallBack = function () {
        iws_SwapClass("Bigbtn", "Multi Over");
    };
    // appele apres la traitement OnMouseOut du manager
    window.mnuMngrProf.OnMouseOutCallBack = function () {
        iws_SwapClass("Bigbtn", "Multi Out");
    };
    // appele apres la traitement de fermeture du manager
    window.mnuMngrProf.OnClose = function () {
        window.mnuMngrProf.CloseSubMenu();
    };
    // appel lors d'un click sur une menu profil
    window.mnuMngrProf.itemClick = function (value) {
        _profilMenuItemClicked(value);
    };
}
window.initMMProf = initMMProf;

/**
 * Traitement lorsqu'on clique sur un item de la liste des profils
 * @param value
 */
function _profilMenuItemClicked(value) {
    //Dysf74182 - CLEM - Menu Home et deconnexion ne fonctionne plus apres une erreur 
    uiCore.clearTreatments();
    uiCore.setSubmit(provocateOnChange());

    const actionContext = new IsiActionContext()
    actionContext.uiAction = {
        menuBarId: MNUP_CHG_PROFIL,
        menuItemId: value.value,
        codeItemList: null,
        addDetailOnForm: false,
        data: undefined,
        detailName: undefined,
        group: undefined,
        id: MNUP_CHG_PROFIL + MNU_SEP + value.value + MNU_SEP + MNU_SEP,
        instanceName: undefined,
        isActionForm: false,
        key: undefined,
        menuGroupId: undefined,
        option: undefined
    }
    actionContext.associatedViewContext = null;
    //118654 - Modification suite popin sur IwsConfirmLostModif
    screenCore.confirmLostModif(actionContext, null, null, {
        func: function () {
            return function (result) {
                if (result == "PostWithoutSave") {
                    const pl: IsiPlDesign = new IsiPlDesign();
                    pl.ManageAuthCookieUpdate("True", null, value.value).then((resultMsg: string) => {
                        // Si on a un message c'est qu'une exception est survenue
                        if (resultMsg) {
                            uiCore.showErrorMessage(resultMsg);
                        } else {
                            // LBRI - 2011.10.13 - [DYSF:xxx] : il faut rediriger le parent car on se trouve dans une frame.
							IsiRedirectJs(appendDiagSessionId(appendSessionId("../../HOMEPAGE.aspx?Action=CHGPROF&bIsRedirected=YES&C_ECRAN=GLOB000&Type=LINK&instanceCode=" + isiApp.dtoClientIWS.IsiCurrentInstanceId)));
                        }
                    });
                }
            }
        }()
    });
}

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : ABON
'- Date        : 30/06/2011
'- Description : [] - Gestion du menu Raccouci
'-----------------------------------------------------------------------------------------*/
//var mnuMngrRac;

export function initMMRac(menuID) {
    window.mnuMngrRac = new IsiSubMenuManager(menuID, null, null, "mnuRac", null);

    //le placement a gauche de ce  menu est dynamique on le precise donc
    window.mnuMngrRac.getLeftPos = function () {
        return -5;
    };
    // appele apres la traitement OnMouseOver du manager
    window.mnuMngrRac.OnMouseOverCallBack = function () {
        iws_SwapClass("DivRacFleche", "FlecheRacImg FlecheRacOverImg");
    };
    // appele apres la traitement OnMouseOut du manager
    window.mnuMngrRac.OnMouseOutCallBack = function () {
        iws_SwapClass("DivRacFleche", "FlecheRacImg FlecheRacOutImg");
    };
    // appele apres la traitement de fermeture du manager
    window.mnuMngrRac.OnClose = function () {
        if (this.mpBoxJQuery[0]?.matches(':hover')) {
            return true;
        }

        if ([...this.mpBoxJQuery[0]?.getElementsByTagName('input')].some(input => input?.matches(':focus'))) {
            return true;
        }

        window.mnuMngrRac.CloseSubMenu();
    };
}
window.initMMRac = initMMRac;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : ABON
'- Date        : 12/04/2011
'- Description : [DEV41555] - Gestion du menu Module
'-----------------------------------------------------------------------------------------*/
//var mnuMngrModule;

export function initMMMngr() {

    window.mnuMngrModule = new IsiSubMenuManager('DivModuleList', 126, null, "mnuMod", null);

    // appele apres la traitement OnMouseOver du manager
    window.mnuMngrModule.OnMouseOverCallBack = function () {
        iws_SwapClass("FlecheModule", "FlecheModuleImgHover");
        iws_SwapClass("DivModuleText", "TextModuleHover");
    };
    // appele apres la traitement OnMouseOut du manager
    window.mnuMngrModule.OnMouseOutCallBack = function () {
        iws_SwapClass("FlecheModule", "FlecheModuleImg");
        iws_SwapClass("DivModuleText", "TextModule");
    };

    // appele apres la traitement de fermeture du manager
    window.mnuMngrModule.OnClose = function () {
        window.mnuMngrModule.CloseSubMenu();
    };
}
window.initMMMngr = initMMMngr;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : ABON
'- Date        : 12/04/2011
'- Description : [DEV41555] - Gestion du menu principal de la page
'-----------------------------------------------------------------------------------------*/
window.mnuMngrPrinc = new IsiMainMenuManager();

export function initMPrincMgr(menuID) {
    // le -2 est repris de normea 
    var left = 88;
    window.mnuMngrPrinc.managers[menuID] = new IsiSubMainMenuManager(menuID + '_SubMenu', left, null, "mnuPrinc", menuID);
}
window.initMPrincMgr = initMPrincMgr;

// JSOU - 23/08/2017 - Permet de retourner l'identifiant du menu
export function getMenuIDFromKey(mainMenuID, typeRac, action) {
    var menuItem;
    menuItem = getMenuItemFromKey(mainMenuID, typeRac, action);
    if (menuItem) {
        return menuItem[0].id;
    } else {
        return menuItem;
    }
}
window.getMenuIDFromKey = getMenuIDFromKey;

// HMLA - 17/06/2015 - RWD - Modification suite à la nouvelle disposition des menus.
export function getMenuItemFromKey(mainMenuID, group, action) {
    var menuItem;
    var menuTreat;

    switch (mainMenuID) {
        case MNU_MASTER:
            // SDEN - 27/03/2012 - DYSF 49166 : Gestion des raccourci clavier pour VT et ecrans de recherche
            // JBUI - 29/03/2012 - DYSF 49222 : Gestion cote client de l'identifiant du menu Navigation affiche
            if (!screenCore.associatedViewManager.exist && screenCore.gridManager.idNavigationMenu === DATA_MNUGRP_NAVIGATION) {
                menuTreat = DATA_MNUGRP_TREATMENT;
            } else {
                menuTreat = FORM_MNUGRP_TREATMENT;
            }
            break;
        default:
            if (mainMenuID.endsWith(MNU_DETAIL)) {
                menuTreat = DATA_MNUGRP_TREATMENT;
            }
            break;
    }

    switch (group) {
        case IsiShortcut.CstMenuNavigation:

            var tempMnuItem;

            if (mainMenuID.endsWith(MNU_DETAIL) && action === "FORM_REFRESH_ITEM") {

                tempMnuItem = screenCore.menuManager.getEntryElementByBarAndKey(mainMenuID, "DATA_REFRESH_ITEM");

            } else if (!mainMenuID.endsWith(MNU_DETAIL) || action.indexOf("FORM_VALIDATE_ITEM") !== 0) {
                // JREV 04/02/2016 - Dysf. 72161 - Si on est dans une DA et que sAction est une action de type Formulaire
                // CLEM - on récupère le mnu pour le raccourci

                tempMnuItem = screenCore.menuManager.getEntryElementByBarAndKey(mainMenuID, action);

                //ABON comportement d'avant si on était sur une DA on tentait de faire l'action sur le formulaire
                if (mainMenuID.endsWith(MNU_DETAIL) && (!tempMnuItem || tempMnuItem.length === 0)) {
                    tempMnuItem = screenCore.menuManager.getEntryElementByBarAndKey(MNU_MASTER, action);
                }
            }

            if (tempMnuItem && tempMnuItem.length > 0) {

                menuItem = tempMnuItem;
            }

            break;

        case IsiShortcut.CstMenuVuesAssociees:
            // HMLA - 17/06/2015 - RWD - Modification suite à la nouvelle disposition des menus.
            menuItem = screenCore.menuManager.getEntryElement(mainMenuID, MNUGRP_ASSOCIATEDVIEW, action);
            break;
        case IsiShortcut.CstMenuActions:
            // HMLA - 17/06/2015 - RWD - Modification suite à la nouvelle disposition des menus.          
            menuItem = screenCore.menuManager.getEntryElement(mainMenuID, menuTreat, action);
            break;
    }

    return menuItem;
}
window.getMenuItemFromKey = getMenuItemFromKey;

export function clickMenuFastMail() {
    getConfigurationFastMail().open(IsiDtoGLOBXXXOpenArgs.fromJS({}), {});
}
window.clickMenuFastMail = clickMenuFastMail;

